import {
  GET_REQUEST_KNOWLEDGE,
  ADD_REQUEST_KNOWLEDGE,
  EDIT_REQUEST_KNOWLEDGE,
  EDIT_REQUEST_STATUS,
} from "../actions/requestKnowledge";

const initialState = [];

// Le store conserve TOUJOURS un tableau de demandes.
export default function requestKnowledgeReducer(state = initialState, action) {
  const list = Array.isArray(state) ? state : Object.values(state || {});

  switch (action.type) {
    case GET_REQUEST_KNOWLEDGE:
      return Array.isArray(action.payload)
        ? action.payload
        : Object.values(action.payload || {});

    case ADD_REQUEST_KNOWLEDGE:
      return action.payload ? [action.payload, ...list] : list;

    // Les deux éditions renvoient la demande complète (avec relations) : on la fusionne.
    case EDIT_REQUEST_KNOWLEDGE:
    case EDIT_REQUEST_STATUS:
      if (!action.payload) return list;
      return list.map((request) =>
        request.id === action.payload.id ? action.payload : request
      );

    default:
      return state;
  }
}
